type MessageLike = {
    attributes?: unknown;
    body?: string | null;
};

const parseAttributes = (attributes: unknown): Record<string, unknown> => {
    if (!attributes) {
        return {};
    }
    if (typeof attributes === "string") {
        try {
            const parsed = JSON.parse(attributes);
            return parsed && typeof parsed === "object" ? parsed : {};
        } catch {
            return {};
        }
    }
    if (typeof attributes === "object") {
        return attributes as Record<string, unknown>;
    }
    return {};
};

/** 进窗排队用的隐藏触发消息，客人界面与历史记录不展示 */
export const isSystemStartMessage = (message?: MessageLike | null) => {
    if (!message) {
        return false;
    }
    const flag = parseAttributes(message.attributes).illuminaSystemStart;
    return flag === true || flag === "true";
};
